import { Box, IconButton } from "@mui/material"
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from "@mui-symbols-material/w300"
import type { CellContext } from "@tanstack/react-table"
import type { FC } from "react"

import { isReviewBlockedBySync } from "../utils"

import { Button } from "@/components/common/Button"
import type { Invoice } from "@/graphql/codegen/graphql"

interface PayableApprovalReviewActionsProps {
  row: CellContext<Invoice, unknown>["row"]
  onReview?: (row: Invoice) => void
}

export const PayableApprovalReviewActions: FC<PayableApprovalReviewActionsProps> = ({ row, onReview }) => {
  const canExpand = row.getCanExpand()

  const handleReviewClick = (): void => {
    onReview?.(row.original)
  }

  const handleExpandClick = (): void => {
    row.getToggleExpandedHandler()()
  }

  return (
    <Box className='flex items-center justify-end gap-x-3'>
      <Button
        appearance='outlined'
        onClick={handleReviewClick}
        disabled={isReviewBlockedBySync(row.original)}
        rootElementName='button'
        data-testid={`payable-approvals.row-actions.review-button-${row.original.invoiceId}`}
      >
        Review
      </Button>
      <IconButton
        size='small'
        onClick={handleExpandClick}
        disabled={!canExpand}
        data-testid={`payable-approvals.row-actions.expand-button-${row.original.invoiceId}`}
      >
        {row.getIsExpanded() ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}
      </IconButton>
    </Box>
  )
}
